export default __webpack_public_path__ + "static/media/hand-point.b681f2f3.svg";